export default __webpack_public_path__ + "static/media/ITOAM-dark.da3cd761.svg";